import { render, staticRenderFns } from "./PreviewAddOnItem.vue?vue&type=template&id=2d8c5239&scoped=true&"
import script from "./PreviewAddOnItem.vue?vue&type=script&lang=js&"
export * from "./PreviewAddOnItem.vue?vue&type=script&lang=js&"
import style0 from "./PreviewAddOnItem.vue?vue&type=style&index=0&id=2d8c5239&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c5239",
  null
  
)

export default component.exports